import { useState, useMemo } from "react";

const usePpfCalculator = () => {

    const [yearlyInvestment, setYearlyInvestment] = useState(100000);
    const [years, setYears] = useState(15);

    const interestRate = 7.1;

    const { maturityValue, investedAmount, totalInterest } = useMemo(() => {

        if (yearlyInvestment <= 0 || years <= 0) {
            return {
                maturityValue: 0,
                investedAmount: 0,
                totalInterest: 0
            };
        }

        const r = interestRate / 100;

        const futureValue =
            yearlyInvestment *
            (((Math.pow(1 + r, years) - 1) / r) * (1 + r));

        const totalInvested = yearlyInvestment * years;

        return {
            maturityValue: Math.round(futureValue),
            investedAmount: totalInvested,
            totalInterest: Math.round(futureValue - totalInvested)
        };

    }, [yearlyInvestment, years, interestRate]);

    return {
        title: "PPF Calculator",

        inputs: [
            {
                label: "Yearly Investment",
                value: yearlyInvestment,
                setter: setYearlyInvestment,
                min: 500,
                max: 150000,
                step: 500,
            },
            {
                label: "Time Period (Years)",
                value: years,
                setter: setYears,
                min: 15,
                max: 50,
                step: 1,
            },
            {
                label: "Interest Rate (p.a)",
                value: interestRate,
                disabled: true,
            },
        ],

        results: [
            { label: "Invested Amount", value: investedAmount },
            { label: "Total Interest", value: totalInterest, highlight: true },
            { label: "Maturity Value", value: maturityValue }
        ],

        totalValue: maturityValue,
        investedAmount,
        estimatedReturns: totalInterest,

        infoContent: {
            heading: "PPF Calculator – Public Provident Fund",
            description:
                "PPF is a government-backed long-term savings scheme offering fixed interest and tax benefits for secure wealth creation.",

            subHeading1: "What is a PPF Calculator?",
            subContent1:
                "A PPF calculator estimates the maturity value of your yearly contributions based on fixed annual interest and investment duration.",

            subHeading2: "How It Works",
            subContent2:
                "It applies annual compound interest on your yearly investments to calculate the final maturity amount.",

            formula: "M = P × ((1 + r)^n − 1) / r × (1 + r)",

            subHeading3: "Benefits",
            benefits: [
                "Safe government-backed investment",
                "Fixed interest returns",
                "Tax-free maturity amount",
                "Ideal for long-term savings goals",
            ],
        }
    };
};

export default usePpfCalculator;